import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../withRouter";
import Search from "../../../components/Search";
import BaseListPage from "../../../base/BaseListPage";
import InputFactory from "../../../components/InputFactory";
import TaxTablePresenter from "./TaxTablePresenter";
import CardView from "../../../components/common/CardView";
import { DialogConfirmation } from "../../../components/common/Converter";
import Progress from "../../../components/Progress";

class TaxTablePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TaxTablePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = { objects: [], count: 0, limit: 10, current: 1 };
  }

  getCollectionName() {
    return "tax-table";
  }

  AddTax() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  // async handleAddButton() {
  //   const data = {
  //     description: this.state.description,
  //     name: this.state.name,
  //     status: "inactive",
  //   };

  //   await this.presenter.upsertUseCase.execute("Region", data);
  //   dialog.close();
  //   this.refetchData();
  // }

  // delete function
  async handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  // edit function
  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }
  async handleViewData(object) {
    this.navigateTo(`/view/${this.getCollectionName()}/${object.id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;

    console.log("OBJECTSSS", objects);
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Reference Table {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        onClick={this.AddTax.bind(this)}
                        // onClick={this.onClickAdd.bind(this)}
                      >
                        <i className="bi bi-plus-lg" /> New {schema.label}
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                viewObject={this.handleViewData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["Id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(TaxTablePage);
